import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaintenanceComponent } from './maintenance.component';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { PageModule } from '@app/shared/components/page/page.module';
import { SharedModule } from 'src/app/shared/shared.module';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    MaintenanceComponent
  ],
  imports: [
    CommonModule,
    PageModule,
    SharedModule,
    LottieComponent
  ],
  exports: [
    MaintenanceComponent
  ],
  providers: [
    provideLottieOptions({
      player: playerFactory
    })
  ]
})
export class MaintenanceModule { }
